import gql from 'graphql-tag';

import { lightCourseCategoryFragment } from '~/shared/graphql-queries/course-categories/course-category-fragment';

export default gql`
  query findManyLightCourseCategoryQuery(
    $limit: Int
    $filter: FilterFindManyCourseCategoryInput
  ) {
    findManyLightCourseCategoryQuery(
      filter: $filter
      skip: 0
      limit: $limit
      sort: _ID_DESC
    ) {
      ...LightCourseCategoryFragment
    }
  }
  ${lightCourseCategoryFragment}
`;
